/**
 * ID helpers
 *
 * The backend sometimes returns Relay global IDs (base64("TypeName:uuid")).
 * REST endpoints typically expect raw UUIDs.
 */
export function decodeRelayId(globalId: string | null | undefined): string | null {
  if (!globalId) return null

  // If it's already a UUID, return as-is.
  if (isUuid(globalId)) return globalId

  try {
    // atob is available in browsers. If it throws, treat as non-base64.
    const decoded = globalThis.atob(globalId)
    const parts = decoded.split(':')
    if (parts.length === 2 && parts[1]) return parts[1]
    return globalId
  } catch {
    return globalId
  }
}

export function isUuid(value: string | null | undefined): boolean {
  if (!value) return false
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
}

